import { Component, OnInit, OnDestroy, AfterViewInit, ViewChild, ElementRef, ViewChildren, ViewContainerRef, QueryList, HostListener, NgZone } from '@angular/core';
import { EventService } from '../../service/event.service';
import { Router } from '@angular/router';
import { CriminalHistoryService } from '../../service/criminalhistory.service';
import { AFCriminalHistoryDomain } from '../../model/af.model';
import { UntypedFormArray, UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { ChangeNavigationEvent, ProgressBarEvent, ValidateAndNavigateEvent, BeforeSubmitErrorEvent, SkipToMainContentEvent } from '../../service/events';
import { AuthService } from '../../service/auth.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { CustomValidatorsService } from '../../service/custom-validators.service';
import { CdkTextareaAutosize } from '@angular/cdk/text-field';
import { take } from 'rxjs/operators';
import { BaseComponent } from 'src/app/base-component';
import { MatSelectionListChange } from '@angular/material/list';

@Component({
  selector: 'app-criminal-history-ous',
  templateUrl: './criminal-history-ous.component.html',
  styleUrls: ['./criminal-history-ous.component.scss']
})
export class CriminalHistoryOUSComponent extends BaseComponent implements OnInit, AfterViewInit, OnDestroy {

  criminalHistoryData: AFCriminalHistoryDomain;
  criminalHistoryForm: UntypedFormGroup;
  maxDate = new Date();
  minDate = new Date(1900, 0, 1);
  step: number = 0;
  sticky: boolean = false;
  menuPosition: any;
  containerWidth: number;
  containerOffsetTop: number;
  hasBeenSubmittted: boolean = false;
  windowScrollAnchor: number = 548; //default without Applicant history
  criminalChange: boolean = false;
  border: boolean = false;
  listCheck: boolean = false;

  @ViewChild("stickyDiv") stickyDivElement: ElementRef;
  @ViewChildren('stickyDiv', { read: ViewContainerRef }) viewContainerRefs: QueryList<any>;
  @ViewChild("addElement") addElement: ElementRef;
  @ViewChild("addButtonElement") addButtonElement: ElementRef;
  @ViewChild("autosize") autosize: CdkTextareaAutosize;
  questions_Category: Array<String> = [];

  constructor(private userService: AuthService, private eventBus: EventService, private criminalHistoryService: CriminalHistoryService, private fb: UntypedFormBuilder,
    private _router: Router, private _snackBar: MatSnackBar, private customValidator: CustomValidatorsService,
    private _ngZone: NgZone) {
    super(eventBus, _router)
  }

  get submit() { return this.criminalHistoryForm.get('submit') }
  get verifyId() { return this.criminalHistoryForm.get('verifyId') }
  get bookmarkUrl() { return this.criminalHistoryForm.get('bookmarkUrl') }
  get afCountryQuestionsList() { return this.criminalHistoryForm.get('afCountryQuestionsList') as UntypedFormArray; }

  ngOnInit() {
    this.subscribeEvents();
    this.createGroup();
  }

  ngAfterViewInit() {
    this.handleZoom();

    this.viewContainerRefs.changes.subscribe(() => {
      if (this.viewContainerRefs.toArray().length) {
        if (this.stickyDivElement) {
          this.containerWidth = this.stickyDivElement.nativeElement.clientWidth;
          this.containerOffsetTop = this.stickyDivElement.nativeElement.offsetTop;
        }
      }
    });

    this.criminalHistoryForm.valueChanges.subscribe(() => {

      setTimeout(() => {
        let progress = this.getPercentage(this.criminalHistoryForm);
        this.eventBus.emit(new ProgressBarEvent({ id: progress }));
      }, 100);
    });

    // retain navigation on page refresh
    let navlink = this.userService.getNavLinks().find(e => e.routerLink === "/criminalHistory-ous");
    this.eventBus.emit(new ChangeNavigationEvent({ id: navlink.id }));
  }

  getPercentage(criminalHistoryForm: UntypedFormGroup): number {
    let errorCount = 0;
    let totalCount = 0;

    for (let container of criminalHistoryForm.get('afCountryQuestionsList')['controls']) {
      for (let controlKey in container.controls) {
        if (container.controls.hasOwnProperty(controlKey)) {
          if (container.controls[controlKey].validator != null) {
            totalCount += container.controls[controlKey].validator.length;
          }
          if (container.controls[controlKey].errors) {
            errorCount += Object.keys(container.controls[controlKey].errors).length;
          }
        }
      }
    }
    let percentage = ((totalCount - errorCount) / totalCount) * 100;
    return percentage;
  }

  setStep(index: number) {
    this.step = index;
  }

  subscribeEvents() {
    this.criminalHistoryService.getCriminalHistory(true).subscribe({
      next: (data: AFCriminalHistoryDomain) => {
        this.criminalHistoryData = data;
        if (this.criminalHistoryData.verifyId == null) {
          this.criminalHistoryData.verifyId = this.userService.getVerifyId();
        }
        this.criminalHistoryForm.patchValue(this.criminalHistoryData);
        this.populateCountryQuestions();
      },
      error: (error: Error) => {
        console.log(error);
      }
    });

    this.sub = this.eventBus.on(
      ValidateAndNavigateEvent,
      (event): void => {
        if (event.payload.currentLink === '/criminalHistory-ous') {
          this.submit.setValue(false);
          this.bookmarkUrl.setValue("");
          if (event.payload.save) {
            this.submitCriminalHistory((this.criminalHistoryForm.value), event);
          } else if (event.payload.saveAndFinishLater) {
            this.bookmarkUrl.setValue(event.payload.currentLink);
            this.submitCriminalHistory((this.criminalHistoryForm.value), event);
          } else if (this.validate()) {
            this.submitCriminalHistory((this.criminalHistoryForm.value), event);
          } else {
            this.eventBus.emit(new BeforeSubmitErrorEvent({}));
          }
        }
      }
    );

    this.eventBus.on(
      SkipToMainContentEvent,
      (event): void => {
        if (event.payload.text && event.payload.text == "/criminalHistory-ous") {
          let mainContentElement = document.querySelector("#main-content"); //check if main-content id exists on page
          if (mainContentElement) {
            mainContentElement.scrollIntoView(true);
          }
        }
      }
    );
  }

  onFocusOutMainContent(event) {
    this.eventBus.emit(new SkipToMainContentEvent({ text: "FocusOff" }));
  }
  submitCriminalHistory(criminalHistory, event) {
    this.criminalHistoryService.submitCriminalHistoryOUS(criminalHistory).subscribe({
      next: () => {
        if (event.payload.save) {
          this._snackBar.open("Saved successfully", "Close", {
            duration: 4000,
          });
        } else if (event.payload.saveAndFinishLater) {
          this._snackBar.open("Saved successfully", "Close", {
            duration: 4000,
          });
          this._router.navigate(['sessionTimedOut']);
        } else {
          this.eventBus.emit(new ChangeNavigationEvent({ id: event.payload.id }));
          this._router.navigateByUrl(event.payload.nextNavLink);
        }
      },
      error: (error: any) => console.log(error)
    });
  }

  handleSelection(event: MatSelectionListChange) {
    event.source.deselectAll();
    event.options[0].selected = true;
    this.step = event.options[0].value;
  }

  focusTarget() {
    setTimeout(() => {
      this.addElement.nativeElement.focus();
      this.border = true;
    });
  }

  @HostListener('document:keydown', ['$event'])
  clearBorder(keyDown: KeyboardEvent) {
    if (keyDown.key === 'Tab') {
      this.border = false;
    }
  }

  @HostListener('click', ['$event'])
  clearBorderClick() {
    this.border = false;
  }

  dropDownScreenReaderCountry(criminal: any): string {
    if (criminal.controls.country.value) {
      return 'Selected ' + this.criminalHistoryData.countryLookup[Object.keys(this.criminalHistoryData.countryLookup).find(e => e === criminal.controls.country.value)];
    } else {
      return 'blank';
    }
  }

  dropDownScreenReaderState(criminal: any): string {
    if (criminal.controls.usState.value) {
      return 'Selected ' + this.criminalHistoryData.usStateLookup[Object.keys(this.criminalHistoryData.usStateLookup).find(e => e === criminal.controls.usState.value)];
    } else {
      return 'blank';
    }
  }

  dropDownScreenReaderOffense(criminal: any): string {
    if (criminal.controls.offenseOrRegulatoryAction.value) {
      return 'Selected ' + criminal.controls.offenseOrRegulatoryAction.value;
    } else {
      return 'blank';
    }
  }

  dropDownScreenReaderOffenseLevel(criminal: any): string {
    if (criminal.controls.levelOfOffense.value) {
      return 'Selected ' + this.criminalHistoryData.offenseLevelLookup[Object.keys(this.criminalHistoryData.offenseLevelLookup).find(e => e === criminal.controls.levelOfOffense.value)];
    } else {
      return 'blank';
    }
  }

  dropDownScreenReaderDisposition(criminal: any): string {
    if (criminal.controls.disposition.value) {
      return 'Selected ' + this.criminalHistoryData.dispositionlookup[Object.keys(this.criminalHistoryData.dispositionlookup).find(e => e === criminal.controls.disposition.value)];
    } else {
      return 'blank';
    }
  }

  @HostListener('window:resize', ['$event'])
  @HostListener('window:load', ['$event'])
  handleZoom() {
    const windowWidth = window.innerWidth;
    const windowHeight = window.innerHeight;
    if (windowWidth <= 935 || windowHeight <= 650) {
      this.criminalChange = true;
    } else {
      this.criminalChange = false;
    }
  }

  @HostListener('window:scroll', ['$event'])
  handleScroll(offSet: number) {
    const windowScroll = window.pageYOffset;
    let offSetTop = this.containerOffsetTop - 125;

    if (typeof offSet === 'number' && offSet != this.containerOffsetTop) {
      this.containerOffsetTop = offSet; //on textbox resize
    }

    if (windowScroll >= this.windowScrollAnchor && windowScroll > offSetTop) {
      this.sticky = true;
    } else {
      this.sticky = false;
    }

    if (offSetTop === 45) {
      this.containerOffsetTop = this.stickyDivElement.nativeElement.offsetTop;
      this.sticky = false; //reset on form value change
    }
  }

  triggerResize() {
    // Wait for changes to be applied, then trigger textarea resize.
    this._ngZone.onStable.pipe(take(1))
      .subscribe(() => this.autosize.resizeToFitContent(true));
  }

  onResized() {
    if (this.stickyDivElement) {
      this.handleScroll(this.stickyDivElement.nativeElement.offsetTop);
    }
  }

  createGroup() {
    this.criminalHistoryForm = this.fb.group({
      submit: [false],
      verifyId: [this.userService.getVerifyId(), []],
      bookmarkUrl: [''],
      afCountryQuestionsList: new UntypedFormArray([])
    });
  }

  ngOnDestroy(): void {
    this.sub.unsubscribe();
  }

  validate() {
    this.submit.setValue(true);
    this.hasBeenSubmittted = true;

    this.criminalHistoryForm.markAllAsTouched();
    return !this.criminalHistoryForm.invalid;
  }


  countryQuestionsGroup(): UntypedFormGroup {
    return this.fb.group({
      id: [''],
      af_id: [''],
      question_id: [''],
      questions: [''],
      answer: ['', [Validators.required]],
      description: [''],
      category: [''],
      country_cd: [''],
    });
  }
  populateCountryQuestions() {
    this.questions_Category = this.criminalHistoryData.afCountryQuestionsList.map(item => item.category).filter((value, index, self) => self.indexOf(value) === index)
    for (let questions of this.criminalHistoryData.afCountryQuestionsList) {
      let fg: UntypedFormGroup = this.countryQuestionsGroup();
      fg.patchValue(questions);
      this.setValidators(fg);
      this.afCountryQuestionsList.push(fg);
    }
    console.log(this.afCountryQuestionsList);

  }
  getQuestionsbasedCategory(value: String) {
    return this.afCountryQuestionsList.controls.filter(a => a.value.category.toUpperCase() == value.toUpperCase());

  }
  setValidators(control: UntypedFormGroup) {
    const answer = control.get('answer');
    answer.valueChanges
      .subscribe(answer => {
        answer.updateValueAndValidity();
      });

  }
}